import React from 'react';
import { Heading, Text, VStack, Container } from '@chakra-ui/react';

const TermsOfService = () => (
  <Container maxW="2xl" centerContent py={12}>
    <VStack spacing={6} align="start">
      <Heading as="h1" size="xl" textAlign="center" width="100%">
        利用規約
      </Heading>

      <Text>
        本利用規約（以下「本規約」）は、当社が提供するポモドーロタイマー（以下「本サービス」）の利用条件を定めるものです。ユーザーは、本サービスを利用することにより、本規約に同意したものとみなされます。
      </Text>

      <Text fontWeight="bold">第1条（適用）</Text>
      <Text>
        本規約は、本サービスの提供条件および利用に関する当社とユーザーとの間の一切の関係に適用されます。
      </Text>

      <Text fontWeight="bold">第2条（禁止事項）</Text>
      <Text>
        ユーザーは、以下の行為をしてはなりません：
        <br />
        ・法令または公序良俗に違反する行為
        <br />
        ・他のユーザーまたは第三者の権利を侵害する行為
        <br />
        ・サービスの運営を妨害する行為
      </Text>

      <Text fontWeight="bold">第3条（知的財産権）</Text>
      <Text>
        本サービスに含まれるすべてのコンテンツ（テキスト、画像、音声、ソースコード等）に関する著作権等の権利は当社または正当な権利者に帰属します。
      </Text>

      <Text fontWeight="bold">第4条（サービス内容の変更・中断等）</Text>
      <Text>
        当社は、ユーザーへの事前の通知なく、本サービスの内容を変更・中断・終了することがあります。これによって生じた損害について、当社は一切責任を負いません。
      </Text>

      <Text fontWeight="bold">第5条（免責事項）</Text>
      <Text>
        本サービスは現状有姿で提供され、完全性・正確性・安全性等について当社は一切保証いたしません。利用により生じた損害についても責任を負いません。
      </Text>

      <Text fontWeight="bold">第6条（規約の変更）</Text>
      <Text>
        当社は、必要と判断した場合には、ユーザーへの通知なく本規約を変更することがあります。変更後の本規約は、本ページに掲載された時点で効力を生じるものとします。
      </Text>

      <Text fontWeight="bold">第7条（準拠法および管轄）</Text>
      <Text>
        本規約は日本法に準拠し、当サービスに関するすべての紛争については、当社所在地を管轄する裁判所を専属的合意管轄とします。
      </Text>

      {/* <Text fontWeight="bold">第8条（お問い合わせ）</Text>
      <Text>
        本サービスまたは本規約に関するお問い合わせは、以下の連絡先までお願いいたします：
        <br />
        例）support@example.com
      </Text> */}
    </VStack>
  </Container>
);

export default TermsOfService;
